import { PartialTheme } from '@fluentui/react/lib/Theme';

const albiniTheme: PartialTheme = {
    palette: {
        themePrimary: '#dc001a',
        themeLighterAlt: '#fef4f5',
        themeLighter: '#f9d4d8',
        themeLight: '#f4afb7',
        themeTertiary: '#e96272',
        themeSecondary: '#e01d34',
        themeDarkAlt: '#c60017',
        themeDark: '#a70014',
        themeDarker: '#7b000f',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    }
}

const albiniDarkTheme: PartialTheme = {
    palette: {
        themePrimary: '#dc001a',
        themeLighterAlt: '#090001',
        themeLighter: '#250004',
        themeLight: '#450008',
        themeTertiary: '#880010',
        themeSecondary: '#c30017',
        themeDarkAlt: '#df1931',
        themeDark: '#e43d51',
        themeDarker: '#eb707f',
        neutralLighterAlt: '#2b2928',
        neutralLighter: '#333231',
        neutralLight: '#41403e',
        neutralQuaternaryAlt: '#4a4846',
        neutralQuaternary: '#514f4d',
        neutralTertiaryAlt: '#6f6c6a',
        neutralTertiary: '#c8c8c8',
        neutralSecondary: '#d0d0d0',
        neutralSecondaryAlt: '#d0d0d0',
        neutralPrimaryAlt: '#dadada',
        neutralPrimary: '#ffffff',
        neutralDark: '#f4f4f4',
        black: '#f8f8f8',
        white: '#201f1e'
    }
};

export { albiniTheme, albiniDarkTheme };